import React from 'react';
import styles from './SelectLanguagePairs.module.scss';
import cn from 'classnames';
import Button from 'components/common/Form/Button';
import { GreenPlusIcon } from 'components/common/icons';
import { useTranslation } from 'react-i18next';
import { TRANSLATE_LANGUAGES } from 'components/common/listConstants';
import Select from 'components/common/Form/Select';
import TrashCanIcon from 'components/common/icons/redesign/TrashCanIcon';

const SelectLanguagePairs = ({ translateLanguages, onChangeField, errors }) => {
    const { t } = useTranslation();

    const handleAddButtonClick = () => {
        onChangeField({
            target: { name: 'translateLanguages', value: [...translateLanguages, { from: null, to: null }] },
        });
    };

    const handleDeleteClick = (ind) => {
        const newRows = translateLanguages.filter((item, index) => index !== ind);
        onChangeField({ target: { name: 'translateLanguages', value: [...newRows] } });
    };

    const handleChange = (type, ind, value) => {
        const newRows = [...translateLanguages];
        newRows[ind][type] = value;
        onChangeField({ target: { name: 'translateLanguages', value: [...newRows] } });
    };

    const buttonText = (
        <>
            <GreenPlusIcon /> {t('welcome:buttons.addPair')}
        </>
    );

    return (
        <div className={styles.selectLanguagePairs}>
            {translateLanguages.map((row, index) => (
                <LanguageRow
                    key={index}
                    index={index}
                    onDeleteClick={handleDeleteClick}
                    onChangeClick={handleChange}
                    from={row.from}
                    to={row.to}
                />
            ))}
            <div className={styles.commonError}>{t(errors.translate)}</div>
            <div className={cn(styles.buttonWrapper, styles.addButton)}>
                <Button text={buttonText} onClick={handleAddButtonClick} />
            </div>
        </div>
    );
};

export const LanguageRow = ({ onChangeClick, onDeleteClick, index, from, to }) => {
    const { t } = useTranslation();
    const options = TRANSLATE_LANGUAGES(t).filter((language) => language.value !== from && language.value !== to);

    return (
        <div className={styles.languageRow}>
            <Select
                label={t('welcome:form.labels.from')}
                placeholder={t('welcome:form.placeholders.language')}
                options={options}
                value={from ? t(`languages.${from}`) : ''}
                onChange={(value) => onChangeClick('from', index, value)}
                labelClassName={styles.labelClassName}
            />
            <Select
                label={t('welcome:form.labels.to')}
                placeholder={t('welcome:form.placeholders.language')}
                options={options}
                value={to ? t(`languages.${to}`) : ''}
                onChange={(value) => onChangeClick('to', index, value)}
                labelClassName={styles.labelClassName}
            />
            <div className={styles.deleteRowButton} onClick={() => onDeleteClick(index)}>
                <TrashCanIcon />
            </div>
        </div>
    );
};

export default SelectLanguagePairs;
